import { ReactNode, HTMLProps, CSSProperties } from "react";

// @ts-ignore
interface RowProps extends HTMLProps<HTMLDivElement>{
    className?: string,
    children?: ReactNode,
    justify?: 'start' | 'end' | 'center' | 'between',
    align?: 'start' | 'end' | 'center'| 'stretch'
    mb?: number,
    wrap?: boolean,
    gap?: number,
    mobileCol?: boolean
}
interface ColProps extends HTMLProps<HTMLDivElement>{
    grow?: number,
    shrink?: number,
    basis?: string|number,
    className?: string,
    children?: ReactNode,
    order?: number
}

const gapScale: Record<number, string> = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
};

const mbScale: Record<number, string> = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
    6: '3rem',
};

const justifyMap: Record<string, string> = {
    start: 'flex-start',
    end: 'flex-end',
    center: 'center',
    between: 'space-between',
};

const alignMap: Record<string, string> = {
    start: 'flex-start',
    end: 'flex-end',
    center: 'center',
    stretch: 'stretch',
};

const Row = ({
    className = '',
    children,
    justify = 'start',
    align = 'start',
    mb = 0,
    wrap = true,
    gap = 3,
    mobileCol = false,
    style: styleProp,
    ...props
}: RowProps) => {
    const rowStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: wrap ? 'wrap' : 'nowrap',
        gap: gapScale[gap] ?? `${gap * 0.25}rem`,
        justifyContent: justifyMap[justify] ?? justify,
        alignItems: alignMap[align] ?? align,
        marginBottom: mbScale[mb] ?? `${mb * 0.25}rem`,
        ...styleProp,
    };

    // mobileCol: column on small screens, row on md+
    const mobileClass = mobileCol ? 'row-mobile-col' : '';

    return <div
        className={`${mobileClass} ${className}`.trim()}
        style={rowStyle}
        {...props}
    >{children}</div>
}

const Col = (
    {
        ref,
        grow = 0,
        shrink = 1,
        basis = '',
        className = '',
        children,
        order = 1,
        style: styleProp,
        ...props
    }: ColProps
) => {
    const colStyle: CSSProperties = {
        flexGrow: grow,
        flexShrink: shrink,
        order: order,
        ...(basis !== '' ? { flexBasis: basis } : {}),
        ...styleProp,
    };

    return <div ref={ref} className={className} style={colStyle} {...props}>{children}</div>
};


export {Row, Col};
